export default "__VITE_ASSET__DO$_0AJU__"